// SEQ-238 the one list of years the P&L sheet's range pickers offer.
//
// Tom needs to type old figures into the project P&L sheet, so the pickers go
// back five years. Every P&L year picker takes its list from here so they
// cannot drift apart again. The dashboard filter has its own, longer list
// (getYearOptions in types/dashboard-filters.ts) and is deliberately separate.

export const PNL_YEARS_BACK = 5;
export const PNL_YEARS_FORWARD = 2;

export function getPnlYearOptions(currentYear: number): number[] {
  const years: number[] = [];
  for (let y = currentYear - PNL_YEARS_BACK; y <= currentYear + PNL_YEARS_FORWARD; y++) {
    years.push(y);
  }
  return years;
}
